module.exports = __webpack_public_path__ + "img/polygon.fc3800ca.svg";